import Vue from "vue";
import Component from "vue-class-component";
import $ from "jquery";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { ParametresInstance } from "../../Controls/Parameters";
import { MessageDto } from "../../../dto/GenApi.iNotPaie.Dto/MessageDto";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

@Component
export default class ModalOuvertureExercice extends Vue {
    public message: MessageDto = { Id: 0, NumeroMessage: 0, NumeroContrat: 0, Titre: "", Message1: "", TypeMessage: "G" };

	public Init(): void {
    	ServicesFactoryInstance.ExercicesService.getMessage("E", 0, data => {
    		if (data != null) {
				this.message = data;
			}
    	});
	}

	public annuler(): void {
    	$("#modalOuvertureExercice").modal("hide");
	}

	public envoyer(): void {
    	if (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.Code != undefined) {
    		this.message.IdSocieteFk = ParametresInstance.societeCourante.Id;
    		if (this.message.Id == 0) {
    			ServicesFactoryInstance.ExercicesService.ajoutMessage(this.message, () => {
    				NotificationServiceInstance.SendSuccess("Le message a bien été créé.");
    			});
    		} else {
    			ServicesFactoryInstance.ExercicesService.updateMessage(this.message, () => {
    				NotificationServiceInstance.SendSuccess("Le message a bien été mis à jours.");
    			});
    		}
    		this.annuler();
    	}
	}
}



// WEBPACK FOOTER //
// ./src/components/exercices/modalOuvertureExercice/modalOuvertureExercice.ts